import { useState } from "react";
import { Button, Input, Modal, Form, Select } from "antd";
import { useGetLocationsQuery } from "../../redux/services/locationsApi";
import {
  CityManagerSelect,
  InputElement
} from "../Booking/common/FormsElements";

const { Option } = Select;

const AddDealerMappingInBrandModal = (props: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { isModalOpen, brand, onCancel, addDealerMapping, selectedDealerMapping, onUpdateDealerMapping, isEditMode } =
    props;

  form.setFieldValue("brand_id", brand?.id);
  form.setFieldValue("brand_name", brand?.name);
  form.setFieldsValue(selectedDealerMapping);

  const { data: cityLocationData } = useGetLocationsQuery({
    location_type: "city",
    all_pages: true
  });
  const cityLocations = cityLocationData?.locations || [];

  const { data: stateLocationsData } = useGetLocationsQuery({
    all_pages: true,
    location_type: "state"
  });
  const stateLocations = stateLocationsData?.locations;


  const onFinish = (values: any) => {
    if (Object.keys(selectedDealerMapping).length === 0) {
      const params = { brandId: brand?.id, dealerMappingData: { dealer_mapping: values } };
      addDealerMapping(params, setLoading, form);
    } else {
      const params = { brandId: brand?.id, dealerMappingData: { dealer_mapping: values }, id: selectedDealerMapping?.id };
      onUpdateDealerMapping(params, setLoading, form);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      title={isEditMode ? "Update Dealer Mapping" : "Add Dealer Mapping"}
      open={isModalOpen}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={false}
    >
      <Form
        name="dealer_mapping_form"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item name="brand_id" style={{ display: "none" }}>
          <Input disabled />
        </Form.Item>

        <Form.Item name="brand_name" label="Brand Name">
          <Input disabled />
        </Form.Item>

        <Form.Item
          label="Dealer Code"
          name="dealer_code"
          rules={[
            { required: true, message: "Please input code" },
            { min: 2, message: "Code must be minimum 2 characters." },
            { max: 10, message: "Code must be maximum 10 characters." }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="dealer_name" label="Dealer Name">
          <Input />
        </Form.Item>

        <Form.Item name="branch_code" label="Branch Code">
          <Input />
        </Form.Item>

        <Form.Item name="branch_name" label="Branch Name">
          <Input />
        </Form.Item>

        <Form.Item name="branch_address" label="Branch Address">
          <Input />
        </Form.Item>

        <Form.Item name="branch_city_id" label="Brand city">
          <Select
            placeholder="Select city"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {cityLocations?.map((loc: any) => (
              <Option key={loc.name} value={loc.id}>
                {loc.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="branch_state_id" label="Brand state">
          <Select
            placeholder="Select state"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {stateLocations?.map((loc: any) => (
              <Option key={loc.name} value={loc.id}>
                {loc.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <InputElement
          label="Branch Pincode"
          name="branch_pin_code"
          rules={[
            {
              pattern: /^[1-9][0-9]{5}$/,
              message: "Please Enter Valid Pincode"
            }
          ]}
        />

        <Form.Item name="dealer_branch_code" label="Dealer Branch Code">
          <Input />
        </Form.Item>

        <CityManagerSelect />

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select status" }]}
        >
          <Select
            placeholder="Select status"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEditMode ? "Update" : "Add"}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddDealerMappingInBrandModal;
